var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-classify"},_vm._l((_vm.form),function(item,index){return _c('node',{key:index,ref:'node'+index,refInFor:true,attrs:{"change":_vm.handleChange,"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }